import React from "react";
import { Typography, Grid, Box, Button } from "@mui/material";
import "./privacy.css";

const Privacy = ({ nextStep, prevStep }) => {
  return (
    <Box className='forms-meeting-container'>
      <Box className='privacy-container'>
        {/* Title */}
        <Typography variant='h4' className='privacy-title' align='center'>
          Privacy
        </Typography>

        {/* Privacy Section */}
        <Grid
          container
          spacing={3}
          justifyContent='center'
          alignItems='center'
          sx={{ backgroundColor: "#EEFBFF", p: 2, mt: 2 }}
        >
          {/* Second Section */}
          <Grid item xs={12} sm={6}>
            <img src='./CYPImages/mobile.png' alt='Bed Illustration' className='privacy-image' />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className='privacy-box'>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#2E3B55", mb: 2 }}>
                Your bedroom is your private space. We will support you to tidy and open your windows daily.
              </Typography>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#2E3B55" }}>
                You will be signing some contracts when you arrive at Little Norway. One of such contracts is the room
                search contract. This is because, we may have to complete a room search if we have concerns for your
                safety.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          justifyContent='center'
          alignItems='center'
          sx={{ backgroundColor: "#ECFFF6", p: 2, mt: 2 }}
        >
          {/* First Section */}
          <Grid item xs={12} sm={6}>
            <Box className='privacy-box'>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#019939", mb: 2 }}>
                At Little Norway, we think it is important for you to have privacy. You have the right to speak to
                family and friends over the phone where contact has been agreed with your social worker.
              </Typography>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#019939" }}>
                To ensure everyone’s safety, the adults at the home might ask questions if they observe you are
                distressed after a phone conversation.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <img src='./CYPImages/sleep.png' alt='Phone Illustration' className='privacy-image' />
          </Grid>
        </Grid>
        <Grid container justifyContent='space-between' alignItems='center' mt={2}>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={prevStep}>
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={nextStep}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box className='bottom-forms' mr={3}>
        <img src='./CYPImages/WormisJaeinSpace.png' alt='Bottom Character' className='bottom-forms-image' />
      </Box>
    </Box>
  );
};

export default Privacy;
